import { render, staticRenderFns } from "./ExternalLinkForm.vue?vue&type=template&id=099f532b&scoped=true"
import script from "./ExternalLinkForm.vue?vue&type=script&lang=js"
export * from "./ExternalLinkForm.vue?vue&type=script&lang=js"
import style0 from "./ExternalLinkForm.vue?vue&type=style&index=0&id=099f532b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f532b",
  null
  
)

export default component.exports